export class ManualPaidAutoDebitSearchCriteria {
  constructor() {
    //this.month = null;
  }

  month!: Date;
}
